// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2ekOG","addWidgetButton":"Header_addWidgetButton__370Yq","dashboardTabs":"Header_dashboardTabs__1jgIJ","active":"Header_active__Kwo-l"};